// Email verification must call POST /auth/verify-email once per token.
// The token is single-use, so a second call (React StrictMode re-running the effect in development,
// or the page remounting in production) would get "Invalid or expired token" and replace the
// "Email Verified!" screen with "Verification Failed". The cache lives at module scope, so it
// survives a remount: every caller for the same token shares the first request's promise.

const requests = new Map(); // token -> Promise<{ ok, alreadyVerified?, error? }>

export function verifyEmailOnce(post, token) {
  if (!requests.has(token)) {
    requests.set(token, Promise.resolve()
      .then(() => post('/auth/verify-email', { token }))
      .then(
        (res) => ({ ok: true, alreadyVerified: !!res?.data?.alreadyVerified }),
        (err) => ({ ok: false, error: err?.response?.data?.error || 'Verification failed — this link may have expired.' }),
      ));
  }
  return requests.get(token);
}

// Once success is shown, a later failure never replaces it.
export function nextVerifyStatus(prev, result) {
  if (prev === 'success') return 'success';
  return result.ok ? 'success' : 'error';
}

// Tests only.
export function _resetVerifyEmailOnce() { requests.clear(); }
